export const xcalacocoBookingsFields = [
  { key: 'folio', label: 'Confirmación' },
  { key: 'housingnumber', label: 'Vivienda / Propietario' },
  { key: 'dateIn', label: 'Estancia', sortable: true },
  { key: 'occupancy', label: 'Pax' },
  { key: 'statusname', label: 'Estatus' },
]

export const xcalacocoBookingStatusOptions = [
  { value: '1', text: 'Solicitada' },
  { value: '2', text: 'Confirmada' },
  { value: '3', text: 'Cancelada' },
  { value: '6', text: 'Pendiente de cancelación' },
  { value: null, text: 'Todos' },
]

export const xcalacocoBookingStatusVariants = {
  1: 'warning',
  2: 'success',
  3: 'danger',
  6: 'info',
}

export const xcalacocoBookingReasonOptions = [
  { value: '1', text: 'Uso propio' },
  { value: '2', text: 'Invitados' },
]

export const xcalacocoBookingDateTypeOptions = [
  { value: null, text: 'Sin fechas' },
  { value: 'datein', text: 'Llegada' },
  { value: 'dateout', text: 'Salida' },
  { value: 'range', text: 'Llegada y Salida' },
  { value: 'createdate', text: 'Creación' },
]
